import React from 'react'
import fbIcon from '../../assets/img/icon-fb.png'
import igIcon from '../../assets/img/icon-ig.png'

const Footer = () => (
  <footer className="Footer" role="navigation">
    <a target="_blank" href="https://www.facebook.com/MUVKO-1507094216184351/">
      <img src={fbIcon} alt="Muvko na Facebooku" />
    </a>
    <a target="_blank" href="https://www.instagram.com/muvko/?hl=cs">
      <img src={igIcon} alt="Muvko na Instagramu" />
    </a>
  </footer>
);

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js